/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import UploadIcon from "@/src/assets/icons/serviceOverview/IconDocumentUpload";
import CallClockIcon from "@/src/assets/icons/generic/IconCallClock";
import SendMailIcon from "@/src/assets/icons/generic/IconSendMail";
import IconCallOrAiService from "@/src/assets/icons/serviceOverview/IconCallOrAiService";
import IconWriting from "@/src/assets/icons/traffic/toggleable/IconWriting";
import HowItWorksSectionBase from "@/src/components/Sections/Common/HowItWorksSection/HowItWorksSectionBase";
import { Link } from "@mui/material";

const HowItWorksSectionAdvocardFlex = () => {
  return (
    <HowItWorksSectionBase
      sections={[
        {
          title: "Schritt 1",
          description: <>Geben Sie <Link href={"#top-checkin"} underline={"none"}><strong>hier</strong></Link> Ihre Versicherungsdaten und E-Mail-Adresse ein.</>,
          icon: IconWriting,
        },
        {
          title: "Schritt 2",
          description: "Stellen Sie Ihre Frage direkt oder buchen Sie eine Erstberatung.",
          icon: IconCallOrAiService,
        },
        {
          title: "Schritt 3",
          description: "Wenn Sie eine Erstberatung buchen, können Sie bei Bedarf gerne ergänzende Dokumente hochladen - beispielsweise Ihren Vertrag.",
          icon: UploadIcon,
        },
        {
          title: "Schritt 4",
          description: "Vereinbaren Sie einen Termin für eine telefonische anwaltliche Beratung.",
          icon: CallClockIcon,
        },
        {
          title: "Schritt 5",
          description: "Erhalten Sie nach der Erstberatung die wichtigsten Infos per E-Mail.",
          icon: SendMailIcon,
        },
      ]}
    />
  );
};

export default HowItWorksSectionAdvocardFlex;
